import React from 'react';
import i18n from '../../i18';
import { Box, TextField, Typography } from '@mui/material';
// @mui

export default class DialogAmountField extends React.Component {
    render() {
        const translatedLabel = i18n.t(`columns.${this.props.field.label}`);
        const placeholderLabel = i18n.t(
            `placeholder.${this.props.field.label}`
        );
        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';
        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2">{translatedLabel + requiredLabel}</Typography>
                <TextField
                    placeholder={placeholderLabel}
                    key={this.props.field.id}
                    margin="dense"
                    id={this.props.field.id}
                    value={this.props.value || ''}
                    fullWidth
                    onChange={(event) =>
                        this.props.onChange(
                            this.props.field.id,
                            event.target.value
                        )
                    }
                ></TextField>
            </Box>
        );
    }
}
